import { toValidIndex as d } from "../../utils/array/index6.js";
import { getPolygonArea as h } from "../core/index14.js";
import { isPolygonClockwise as p } from "../is-polygon-clockwise/index.js";
import { rayPolygonIntersection as x } from "../ray-polygon-intersection/index.js";
function w({ polygon: r, ray: l }) {
  r = p(r) ? r : r.slice().reverse();
  const n = x({ polygon: r, ray: l });
  if (n.length < 2)
    return [r];
  const f = [];
  for (let t = 0; t < n.length - 1; t++) {
    if (n[t].enters === !1)
      continue;
    let { poly: e, lastConsumed: s } = c({ polygon: r, intersections: n, start: t, dir: -1 });
    !e || (e = e.filter((i, u, a) => u === 0 || !i.equals(a[u - 1])), e.reverse(), h(e.map((i) => i.toArray())) < 1e-3) || (f.push(e), t = s);
  }
  for (let t = 0; t < n.length - 1; t++) {
    if (n[t].enters === !1)
      continue;
    let { poly: e, lastConsumed: s } = c({ polygon: r, intersections: n, start: t, dir: 1 });
    !e || (e = e.filter((i, u, a) => u === 0 || !i.equals(a[u - 1])), h(e.map((i) => i.toArray())) < 1e-4) || (f.push(e), t = s);
  }
  return f.length > 0 ? f : [r];
}
function c({ polygon: r, intersections: l, start: n, dir: f }) {
  const t = f === 1 ? 1 : 0, e = [], s = l[n].index + t;
  let o = n, i = n;
  for (; ; ) {
    if (!l[o + 1])
      return { poly: void 0, lastConsumed: o };
    i = o, e.push(l[o].point), e.push(l[o + 1].point);
    let u;
    for (let m = o + 2; m < l.length; m++)
      if (l[m].enters === !0) {
        u = l[m].index + t;
        break;
      }
    let a = l[o + 1].index + t;
    for (; u !== a; ) {
      if (s === a)
        return e.push(l[n].point), { poly: e, lastConsumed: i };
      e.push(r[a]), a = d(r, a + f);
    }
    o += 2;
  }
}
export {
  w as SlicePolygon
};
//# sourceMappingURL=index.js.map
